import { render, staticRenderFns } from "./JdProductTable.vue?vue&type=template&id=262cd416&scoped=true&"
import script from "./JdProductTable.vue?vue&type=script&lang=js&"
export * from "./JdProductTable.vue?vue&type=script&lang=js&"
import style0 from "./JdProductTable.vue?vue&type=style&index=0&id=262cd416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262cd416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
